import { T } from "@/locales";

export const columns = [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("盘点单号"),
    dataIndex: "stock_check_order_number",
    sorter: true,
    width: 180,
    ellipsis: true,
    scopedSlots: { customRender: "stock_check_order_number" },
  },
  {
    title: T("仓库名称"),
    dataIndex: "warehouse_name",
    width: 120,
    ellipsis: true,
 },
  {
    title: T("操作人"),
    dataIndex: "creator_name",
    width: 120,
    ellipsis: true,
 },
  {
    title: T("单据创建人"),
    dataIndex: "order_creator_name",
    width: 120,
    ellipsis: true,
 },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    sorter: true,
    width: 180,
    ellipsis: true,
 },
  {
    title: T("备注"),
    dataIndex: "remark",
    width: 240,
    ellipsis: true,
 },
  {
    title: T("操作"),
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    fixed: "right",
    width: 120,
 },
];
